import { render } from "./LoadingSpinner.vue?vue&type=template&id=b47ba0e2"
import script from "./LoadingSpinner.vue?vue&type=script&lang=js"
export * from "./LoadingSpinner.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\User\\Documents\\GitHub\\rubanero14-Convert-XML-to-JSON-Guide\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__